import {
  ImageCarousel,
  INamedImage,
} from "@faire/retailer-visitor-shared/components/ImageCarousel/ImageCarousel";
import { TrackedLink } from "@faire/retailer-visitor-shared/components/TrackedLink/index";
import { PAGE_TYPE } from "@faire/retailer-visitor-shared/consts/PAGE_TYPE";
import { TransparencyOverlay } from "@faire/web/ui/TransparencyOverlay";
import { trackBrandTileClickBrandTileImageScrollClick } from "@faire/web-api--source/events/brandTile/click/clickBrandTileImageScroll";
import React, { useCallback } from "react";

interface IPropTypes {
  token?: string;
  name?: string;
  images: INamedImage[];
  linkLocation?: string;
  eventPath?: string;
  onLinkClick?: () => void;
  title?: string | undefined;
  pageType?: PAGE_TYPE;
}

export const BrandTileImageSection: React.FC<IPropTypes> = ({
  title,
  pageType,
  images,
  onLinkClick,
  linkLocation,
  token,
  name,
}) => {
  const imageWrapper = useCallback(
    (p: object) => (
      <TrackedLink
        {...p}
        token={token}
        onClick={() => {
          onLinkClick?.();
        }}
        to={linkLocation}
      />
    ),
    [token, onLinkClick, linkLocation]
  );

  return (
    <ImageCarousel
      title={title}
      pageType={pageType}
      images={images}
      ImageWrapper={imageWrapper}
      name={name ?? ""}
      hideDotsWhenSingleImage
      otelSpanName="BrandTileImage"
      onImageScrolled={(index, action) => {
        trackBrandTileClickBrandTileImageScrollClick(
          token ?? "",
          index.toString(),
          action
        );
      }}
    >
      <TransparencyOverlay />
    </ImageCarousel>
  );
};
